import Image from "next/image";

const NextImage = ({
  className,
  src,
  alt,
  width,
  height,
  priority = false,
  quality = "75",
  ...props
}) => {
  return (
    <Image
      src={src}
      alt={alt || "Image"}
      className={className}
      priority={priority}
      sizes="(max-width: 768px) 50vw, (max-width: 1200px) 50vw, 100vw"
      width={width}
      height={height}
      quality={quality}
      {...props}
    />
  );
};

export default NextImage;
